import React from 'react';

function etiquetaNumeroComprobante(mov) {
  if (mov?.numero_recibo != null && mov.numero_recibo !== '') {
    return `Recibo N° ${mov.numero_recibo}`;
  }
  if (mov?.numero_pago_cuenta != null) {
    return `Pago a cuenta N° ${mov.numero_pago_cuenta}`;
  }
  if (mov?.numero_pago != null) {
    return `OP N° ${mov.numero_pago}`;
  }
  return null;
}

function badgeMarca(mov) {
  const tipo = mov?.marca_tipo;
  if (!tipo) return null;
  if (tipo === 'cheque_devuelto') {
    return {
      label: 'CH devuelto',
      title: mov.marca_detalle || mov.concepto || 'Cheque de tercero devuelto/rechazado',
      bg: '#fde8e8',
      color: '#9b1c1c',
    };
  }
  if (tipo === 'gasto_rechazo_cheque') {
    return {
      label: 'Gasto rechazo CH',
      title: mov.marca_detalle || mov.concepto || 'Gastos bancarios por rechazo de cheque',
      bg: '#fef3c7',
      color: '#92400e',
    };
  }
  return {
    label: String(tipo),
    title: mov.marca_detalle || '',
    bg: '#eef2ff',
    color: '#3730a3',
  };
}

export function textoAclaracionMovimiento(mov) {
  const numero = etiquetaNumeroComprobante(mov);
  if (numero) return numero;
  return mov?.movimiento_predefinido_descripcion || '';
}

export function MovimientoConceptoCell({ mov, title }) {
  const numero = etiquetaNumeroComprobante(mov);
  const predef = mov?.movimiento_predefinido_descripcion;
  const aclaracion = numero
    ? `📋 ${numero}`
    : predef
      ? `📋 ${predef}`
      : null;
  const badge = badgeMarca(mov);

  return (
    <>
      <div title={title} style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <span>{mov.concepto}</span>
        {badge && (
          <span
            title={badge.title}
            style={{
              fontSize: 10,
              fontWeight: 600,
              letterSpacing: '0.02em',
              padding: '1px 6px',
              borderRadius: 4,
              background: badge.bg,
              color: badge.color,
              whiteSpace: 'nowrap',
            }}
          >
            {badge.label}
          </span>
        )}
      </div>
      {aclaracion && (
        <div style={{ fontSize: '11px', color: '#667eea', marginTop: '2px', fontStyle: 'italic' }}>
          {aclaracion}
        </div>
      )}
      {badge?.title && mov.marca_detalle && (
        <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
          {mov.marca_detalle}
        </div>
      )}
    </>
  );
}
